import React, { useState } from 'react';
import { Image } from 'react-bootstrap';
import { Col, Row } from 'reactstrap';
import CloseIcon from '@mui/icons-material/Close';
import '../../../assets/style/Banner.css';
import ImagePreviewModal from '../../modals/ImagePreviewModal';

interface IBannersPreviewProps {
  banners: any[];
  handleRemove: (id: number) => void;
  keyId: string;
  keyUrlName: string;
  showPreviewImage?: boolean;
}

const BannersPreview: React.FunctionComponent<IBannersPreviewProps> = ({
  banners,
  handleRemove,
  keyId,
  keyUrlName,
  showPreviewImage = false,
}) => {
  const [openImagePreview, setOpenImagePreview] = useState<boolean>(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState<string>('');

  const toggleImageModal = () => {
    setOpenImagePreview(false);
    setSelectedImageUrl('');
  };

  const handleSelectedImage = (image: any) => {
    setSelectedImageUrl(image);
    setOpenImagePreview(true);
  };

  return (
    <div className="files-container mt-3">
      {banners.length > 0 && (
        <Row>
          {banners.map((banner) => (
            <Col
              lg={4}
              md={6}
              sm={6}
              xs={12}
              key={banner?.[keyId]}
              className="mt-3 banner"
            >
              <div className="clear-button">
                <CloseIcon
                  className="remove-icon"
                  onClick={() => {
                    handleRemove(banner?.[keyId]);
                  }}
                />
              </div>
              <div className="uploaded-file-card d-flex align-items-center justify-content-center">
                <Image
                  src={banner?.[keyUrlName]}
                  height={'170'}
                  onClick={() => {
                    if (showPreviewImage) {
                      handleSelectedImage(banner?.[keyUrlName]);
                    }
                  }}
                  alt="image-preview"
                  className="banner-image"
                />
              </div>
            </Col>
          ))}
        </Row>
      )}
      <ImagePreviewModal
        isItUrl={true}
        isOpen={openImagePreview}
        onApproveRejectAction={() => {}}
        photoURL={selectedImageUrl}
        toggle={toggleImageModal}
      />
    </div>
  );
};

export default BannersPreview;
